import React from 'react';
import { Form } from 'react-bootstrap';
import useHeroMetaData from '~/hooks/useHeroMetaData';
import { FormText, FormSelect, Switch } from '~/components/FormControl';

function BasicDetail() {
    const heroMetaData = useHeroMetaData();
    const { characterClasses } = heroMetaData;

    return (
        <>
            {characterClasses?.length > 0 && (
                <Form.Row className="justify-content-around">
                    <FormText
                        sm="3"
                        name="name"
                    />
                    <Switch name="hasHalfwishRefreshed" />

                    <FormSelect
                        name="characterClassId"
                        options={characterClasses || []}
                        sm={3}
                        label="Character Class"
                    />
                </Form.Row>
            )}
        </>
    );
}

export default BasicDetail;
